import { GridWidgetService } from '../grid-widget.services';
import { SystemService } from 'common/services/core-services/system.service';
import { MetaModel, WidgetModel } from 'common/models/utility-models/base-model';
import { Injectable } from '@angular/core';
import { BatchListDataService } from 'common/services/data-services/custom-service/batch-service';
import { branchListDataService } from 'common/services/data-services/custom-service/branchList-service';
import { stateListDataService } from 'common/services/data-services/custom-service/stateList-service.service';
import { CompanyGridDataService } from 'common/services/data-services/admin/internship-company/company-grid-data.service';
import { PlacementReportsDataService } from 'common/services/data-services/admin/reports/placement-reports.service';
import { PlacementReportsModel } from 'common/models/page-models/reports/placement-reports/placement-report-data.model';
import { PlacementReportsGridMetaModel } from 'common/models/page-models/reports/placement-reports/placement-reports-grid-meta.model';
import { PlacementReportsListingModel } from 'common/models/page-models/reports/placement-reports/placement-reports-grid-model';


@Injectable({
    providedIn: 'root'
})
export class PlacementReportsWidgetService extends GridWidgetService<PlacementReportsModel, PlacementReportsListingModel> {
    constructor(protected override ds: PlacementReportsDataService, protected systemService: SystemService, private batchListService: BatchListDataService, private branchListService: branchListDataService, private stateService: stateListDataService, private companyListService: CompanyGridDataService) {
        super(ds);
    }

    getMetaModel(): MetaModel {
        const meta = new PlacementReportsGridMetaModel().getMetaModel();
        return meta;
    }

    override prepareMetaModel(dataModel: PlacementReportsListingModel, metaModel: PlacementReportsGridMetaModel, routeData: WidgetModel): Promise<PlacementReportsGridMetaModel> {
        return new Promise<PlacementReportsGridMetaModel>((resolve, reject) => {
            
            this.batchListService.postData('').then((data) =>{
                metaModel.filterMeta.properties.selectedBatch.options = data.details;
            });
            this.branchListService.postData('').then((data) =>{
                metaModel.filterMeta.properties.selectedBranch.options = data.details;
            });
            this.stateService.postData('').then((data) =>{
                metaModel.filterMeta.properties.selectedState.options = data.details;
            });
            resolve(metaModel);
        });
    }

}